import styled from "@emotion/styled";
import {
  Box,
  Button,
  FormControl,
  Grid,
  InputLabel,
  MenuItem,
  Paper,
  Select,
  TableBody,
  TableCell,
  TableHead,
  TableRow,
  TextField,
  Table,
  ToggleButton,
  ToggleButtonGroup,
  CircularProgress,
  Chip,
  Autocomplete,
} from "@mui/material";
import { useState } from "react";
import { Check } from "react-feather";
import { NumericFormat } from "react-number-format";
import { useDispatch } from "react-redux";
import { useNavigate } from "react-router-dom";
import { showSnackbar } from "../../../redux/slices/snackbar";
import { API_BASE_URL } from "../../../config";

const ITEM_HEIGHT = 62;
const ITEM_PADDING_TOP = 8;
const MenuProps = {
  PaperProps: {
    style: {
      maxHeight: ITEM_HEIGHT * 4.5 + ITEM_PADDING_TOP,
    },
  },
};

const TableWrapper = styled.div`
  overflow-y: auto;
  max-width: calc(100vw - ${(props) => props.theme.spacing(4)});
`;

const Preventivo = ({ form, setForm, province, setPreventivo }) => {
  const [buttonClicked, setButtonClicked] = useState(false);
  const [loading, setLoading] = useState(false);
  const [pacchettiPrezzi, setPacchettiPrezzi] = useState([]);
  const [selected, setSelected] = useState({
    base: false,
    medio: false,
    collissione: false,
    kasko: false,
  });

  const navigate = useNavigate();

  const dispatchSnackbar = useDispatch();

  // Snackbar helper
  const handleSnackbar = (message, severity) => {
    dispatchSnackbar(showSnackbar({ message, severity }));
  };

  const rows = [
    {
      garanzia: "Furto e Incendio",
      base: true,
      medio: true,
      collissione: true,
      kasko: true,
    },
    {
      garanzia: "Ricorso terzi da incendio",
      base: true,
      medio: true,
      collissione: true,
      kasko: true,
    },
    {
      garanzia: "Pacchetto accessori",
      base: true,
      medio: true,
      collissione: true,
      kasko: true,
    },
    {
      garanzia: "Cristalli",
      base: true,
      medio: true,
      collissione: true,
      kasko: true,
    },
    {
      garanzia: "Eventi atmosferici",
      base: false,
      medio: true,
      collissione: true,
      kasko: true,
    },
    {
      garanzia: "Atti vandalici",
      base: false,
      medio: true,
      collissione: true,
      kasko: true,
    },
    {
      garanzia: "Urto con animali",
      base: false,
      medio: true,
      collissione: true,
      kasko: true,
    },
    {
      garanzia: "Collisione",
      base: false,
      medio: false,
      collissione: true,
      kasko: false,
    },
    {
      garanzia: "Kasko",
      base: false,
      medio: false,
      collissione: false,
      kasko: true,
    },
    {
      garanzia: "Infortuni del conducente",
      base: false,
      medio: false,
      collissione: false,
      kasko: false,
    },
    {
      garanzia: "Valore a nuovo (24 mesi)",
      base: true,
      medio: true,
      collissione: true,
      kasko: true,
    },
  ];

  async function cvtGetPacchettiPrezzi() {
    const token = sessionStorage.getItem("token");
    try {
      const requestOptions = {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          authorization: "Bearer " + token,
        },
        body: JSON.stringify({
          token,
          data: {
            satellitare: form.filtri.satellitare,
            valore: form.filtri.valoreVeicolo,
            durata: form.filtri.durata,
            provincia: form.filtri.provincia,
          },
        }),
      };

      const response = await fetch(
        `${API_BASE_URL}/api/cvtCovea`,
        requestOptions
      );

      const responseData = await response.json();
      if (responseData.status === -1) {
        navigate("/auth/sign-in");
      }

      if (responseData.status === 0) {
        handleSnackbar(responseData.message, "error");
        return;
      }

      setButtonClicked(true);
      setPacchettiPrezzi(responseData.data);
    } catch (error) {
      console.log(error);
      return error;
    }
  }

  const handleClick = () => {
    setLoading(true);
    cvtGetPacchettiPrezzi().finally(() => setLoading(false));
  };

  function formatPrice(price) {
    // Convert number to string
    const numberPrice = Number(price);

    // Fallback for invalid input

    let priceStr = numberPrice.toFixed(2);

    // Split the integer part from the decimal part
    let parts = priceStr.split(".");
    let integerPart = parts[0];
    let decimalPart = parts[1];

    // Insert periods for thousands separator
    integerPart = integerPart.replace(/\B(?=(\d{3})+(?!\d))/g, ".");

    // Combine integer and decimal parts with comma as decimal separator
    return integerPart + "," + decimalPart;
  }

  return (
    <>
      <Grid
        container
        spacing={3}
        wrap="wrap"
        sx={{ maxWidth: { xs: "calc(100vw - 60px)" } }}
      >
        <Grid item sm={3} xs={12}>
          <FormControl
            size="small"
            fullWidth
            margin="none"
            required
            /*    error={Boolean(errors.datiResponsabile.provincia)} */
          >
            <InputLabel id="satellitare-label">Satellitare</InputLabel>
            <Select
              labelId="satellitare-label"
              id="satellitare"
              name="satellitare"
              label="Satellitare"
              value={form.filtri.satellitare}
              MenuProps={MenuProps}
              onChange={(e) => {
                setForm({
                  ...form,
                  filtri: {
                    ...form.filtri,
                    satellitare: e.target.value,
                  },
                });
              }}
            >
              <MenuItem value={1}>Si</MenuItem>
              <MenuItem value={0}>No</MenuItem>
            </Select>
          </FormControl>
        </Grid>
        <Grid item sm={3} xs={12}>
          <NumericFormat
            customInput={TextField}
            prefix="€"
            label="Valore Veicolo"
            required
            thousandSeparator="."
            decimalSeparator=","
            decimalScale={2}
            id="fee/Generale"
            name="fee/Generale"
            fullWidth
            valueIsNumericString
            value={form.filtri.valoreVeicolo}
            onValueChange={(e) => {
              setForm({
                ...form,
                filtri: {
                  ...form.filtri,
                  valoreVeicolo: e.value,
                },
              });
            }}
          />
        </Grid>
        <Grid item sm={3} xs={12}>
          <FormControl
            size="small"
            fullWidth
            margin="none"
            required
            /*    error={Boolean(errors.datiResponsabile.provincia)} */
          >
            <InputLabel id="durata-label">Durata</InputLabel>
            <Select
              labelId="durata-label"
              id="durata"
              name="durata"
              label="Durata"
              value={form.filtri.durata}
              MenuProps={MenuProps}
              onChange={(e) => {
                setForm({
                  ...form,
                  filtri: {
                    ...form.filtri,
                    durata: e.target.value,
                  },
                });
              }}
            >
              {[12, 24, 36, 48, 60].map((value) => (
                <MenuItem key={value} value={value}>
                  {value}
                </MenuItem>
              ))}
            </Select>
          </FormControl>
        </Grid>
        <Grid item sm={3} xs={12}>
          <Autocomplete
            size="small"
            fullWidth
            options={province}
            getOptionLabel={(option) => option.nome}
            value={
              province.find((p) => p.sigla === form.filtri.provincia) || null
            }
            onChange={(_, newValue) => {
              setForm({
                ...form,
                filtri: {
                  ...form.filtri,
                  provincia: newValue ? newValue.sigla : "",
                },
              });
            }}
            renderInput={(params) => (
              <TextField
                {...params}
                label="Provincia"
                required
                /* error={Boolean(errors.datiResponsabile.provincia)} */
              />
            )}
          />
        </Grid>
      </Grid>
      <Box mt={8} display="flex" justifyContent="center">
        <Button
          variant="contained"
          disabled={
            form.filtri.valoreVeicolo >= 10000 && form.filtri.provincia !== ""
              ? false
              : true
          }
          onClick={handleClick}
        >
          Calcola
        </Button>
      </Box>
      {buttonClicked &&
        (loading ? (
          <Box
            sx={{
              width: "calc(100vw - 40px)",
              display: "flex",
              justifyContent: "center",
            }}
          >
            <CircularProgress />
          </Box>
        ) : (
          <Box
            mt={8}
            display="flex"
            justifyContent="center"
            flexDirection="column"
            gap={8}
          >
            <Paper>
              <TableWrapper>
                <Table sx={{ minWidth: 650 }} aria-label="simple table">
                  <TableHead>
                    <TableRow>
                      <TableCell></TableCell>

                      {pacchettiPrezzi.map((prezzo) => {
                        let formattedPrice = formatPrice(prezzo.prezzo);
                        return (
                          <TableCell align="center" key={prezzo.prodotto}>
                            <h1 sx={{ fontSize: "20px" }}>{prezzo.prodotto}</h1>
                            <Chip
                              sx={{
                                backgroundColor: "transparent",
                                color: "#e86717ff",
                                fontSize: "20px",
                                fontWeight: "bold",
                              }}
                              label={"€" + formattedPrice}
                            />
                          </TableCell>
                        );
                      })}
                    </TableRow>
                  </TableHead>

                  <TableBody>
                    {rows.map((row) => (
                      <TableRow
                        key={row.garanzia}
                        sx={{
                          "&:last-child td, &:last-child th": { border: 0 },
                        }}
                      >
                        <TableCell sx={{ paddingY: 2 }} scope="row">
                          {row.garanzia}
                        </TableCell>
                        <TableCell sx={{ paddingY: 2 }} align="center">
                          {row.base && <Check />}
                        </TableCell>
                        <TableCell sx={{ paddingY: 2 }} align="center">
                          {row.medio && <Check />}
                        </TableCell>
                        <TableCell sx={{ paddingY: 2 }} align="center">
                          {row.collissione && <Check />}
                        </TableCell>
                        <TableCell sx={{ paddingY: 2 }} align="center">
                          {row.kasko && <Check />}
                        </TableCell>
                      </TableRow>
                    ))}
                    <TableRow>
                      <TableCell />
                      <TableCell align="center">
                        <ToggleButton
                          sx={{
                            "&:hover": { backgroundColor: "#cf6a21" },
                            "&.Mui-selected, &.Mui-selected:hover": {
                              backgroundColor: "#ff6b01",
                            },
                          }}
                          fullWidth
                          value="base"
                          selected={selected.base}
                          onChange={() => {
                            setSelected({
                              medio: false,
                              base: true,
                              collissione: false,
                              kasko: false,
                            });
                            setPreventivo("base");
                          }}
                        >
                          Seleziona
                        </ToggleButton>
                      </TableCell>
                      <TableCell align="center">
                        <ToggleButton
                          selected={selected.medio}
                          onChange={() => {
                            setSelected({
                              medio: true,
                              base: false,
                              collissione: false,
                              kasko: false,
                            });
                            setPreventivo("medio");
                          }}
                          sx={{
                            "&:hover": { backgroundColor: "#cf6a21" },
                            "&.Mui-selected, &.Mui-selected:hover": {
                              backgroundColor: "#ff6b01",
                            },
                          }}
                          fullWidth
                          value="medio"
                        >
                          Seleziona
                        </ToggleButton>
                      </TableCell>
                      <TableCell align="center">
                        <ToggleButton
                          selected={selected.collissione}
                          onChange={() => {
                            setSelected({
                              medio: false,
                              base: false,
                              collissione: true,
                              kasko: false,
                            });
                            setPreventivo("collisione");
                          }}
                          sx={{
                            "&:hover": { backgroundColor: "#cf6a21" },
                            "&.Mui-selected, &.Mui-selected:hover": {
                              backgroundColor: "#ff6b01",
                            },
                          }}
                          fullWidth
                          value="collisione"
                        >
                          Seleziona
                        </ToggleButton>
                      </TableCell>
                      <TableCell align="center">
                        <ToggleButton
                          selected={selected.kasko}
                          onChange={() => {
                            setSelected({
                              medio: false,
                              base: false,
                              collissione: false,
                              kasko: true,
                            });
                            setPreventivo("kasko");
                          }}
                          sx={{
                            "&:hover": { backgroundColor: "#cf6a21" },
                            "&.Mui-selected, &.Mui-selected:hover": {
                              backgroundColor: "#ff6b01",
                            },
                          }}
                          fullWidth
                          value="kasko"
                        >
                          Seleziona
                        </ToggleButton>
                      </TableCell>
                    </TableRow>
                  </TableBody>
                </Table>
              </TableWrapper>
            </Paper>
          </Box>
        ))}
    </>
  );
};

export default Preventivo;
